export default __webpack_public_path__ + "static/media/amazon-logo.19c76a95.png";